<template>
    <div>
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    mode="eager"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                >
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <v-text-field
                        p
                        v-model="urlVal"
                        v-bind="vProps"
                        :error-messages="errors"
                        :prepend-icon="computedIcon"
                        @focus="prependHttps()"
                        hide-details="auto"
                    >
                        <template #label>
                            <span v-if="innerLabel" v-html="innerLabel"></span>
                        </template>
                    </v-text-field>
                </validation-provider>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';

export default {
    name: 'TypeTextBox',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    props: {
        showIcon: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    methods: {
        prependHttps() {
            if (!this.innerValue) this.innerValue = 'https://';
        }
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true,
                persistentPlaceholder: true,
                placeholder: 'https://'
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                required:
                    !!this.validation_settings.required &&
                    !!this.innerShouldShow,
                url: true
            } : {};
        },
        computedIcon() {
            return this.showIcon ? 'mdi-web' : undefined;
        },
        urlVal: {
            get() {
                return this.innerValue;
            },
            set(v) {
                this.innerValue = v;
            }
        }
    }
};
</script>
